import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  TextField
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

import Button from "components/CustomButtons/Button.js";
import styles from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import { makeStyles } from "@material-ui/core/styles";
import { Close } from "@material-ui/icons";
import { wsGet } from "services/WService.js";
import { WithApp } from "contexts/appContext";
import useItemChanges from "hooks/useItemChanges";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default WithApp(function ContactModal(props) {
  const classes = useStyles();

  const contactId = props.contactId;

  const [contact, setContact] = useState({});
  const [contactLoaded, setContactLoaded] = useState({});
  const itemChanges = useItemChanges(contactLoaded, contact);

  async function getContact() {
    setContactLoaded({});
    const response = await wsGet("base/business-partner-contact", contactId);
    if (response.success) {
      setContactLoaded(response.data);
      setContact(response.data);
    }
  }

  const handleClose = () => {
    props.close(false);
  };

  const handleSave = () => {
    if (itemChanges) props.save(itemChanges);
    else handleClose();
  };

  const handleChange = (e) => {
    setContact({
      ...contact,
      [e.target.name]: e.target.value
    });
  };

  useEffect(() => {
    if (props.open === true && props.contactId) {
      getContact();
    }
  }, [props.open]);
  return (
    <Dialog
      classes={{
        root: classes.center + " " + classes.modalRoot,
        paper: classes.modal
      }}
      open={props.open}
      onClose={handleClose}
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogTitle disableTypography className={classes.modalHeader}>
        <Button
          justIcon
          className={classes.modalCloseButton}
          key="close"
          aria-label="Close"
          color="transparent"
          onClick={handleClose}
        >
          <Close className={classes.modalClose} />
        </Button>
        <h4 className={classes.modalTitle}>
          <b>Contactos</b>
        </h4>
      </DialogTitle>
      <DialogContent className={classes.modalBody}>
        <form autoComplete="off">
          <GridContainer>
            <GridItem xl={6}>
              <TextField
                label="ID contacto"
                fullWidth
                name="Name"
                margin="normal"
                size="small"
                value={contact.Name || ""}
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true
                }}
              />
              <TextField
                label="Primer Nombre"
                fullWidth
                name="FirstName"
                margin="normal"
                size="small"
                value={contact.FirstName || ""}
                onChange={handleChange}
              />
              <TextField
                label="Segundo Nombre"
                fullWidth
                name="MiddleName"
                value={contact.MiddleName || ""}
                margin="normal"
                size="small"
                onChange={handleChange}
              />
              <TextField
                label="Apellidos"
                fullWidth
                name="LastName"
                value={contact.LastName || ""}
                margin="normal"
                size="small"
                onChange={handleChange}
              />
              <TextField
                label="Fec. Nacimiento"
                fullWidth
                name="BirthDate"
                value={contact.BirthDate || ""}
                type="date"
                InputLabelProps={{
                  shrink: true
                }}
                margin="normal"
                size="small"
                onChange={handleChange}
              />
              <TextField
                label="Lugar Nacimiento"
                fullWidth
                name="BirthCity"
                value={contact.BirthCity || ""}
                margin="normal"
                size="small"
                onChange={handleChange}
              />
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Género</InputLabel>
                <Select
                  value={contact.Gender || ""}
                  inputProps={{
                    name: "Gender",
                    onChange: handleChange
                  }}
                >
                  <MenuItem value="M">Masculino</MenuItem>
                  <MenuItem value="F">Femenino</MenuItem>
                </Select>
              </FormControl>
            </GridItem>
            <GridItem xl={6}>
              <TextField
                label="Dirección"
                fullWidth
                name="Address"
                value={contact.Address || ""}
                margin="normal"
                size="small"
                onChange={handleChange}
              />
              <TextField
                label="Teléfono"
                fullWidth
                name="Tel1"
                value={contact.Tel1 || ""}
                type="number"
                margin="normal"
                size="small"
                max="5"
                onChange={handleChange}
              />
              <TextField
                label="Celular"
                fullWidth
                name="Cellolar"
                value={contact.Cellolar || ""}
                maxLength="9"
                margin="normal"
                size="small"
                inputProps={{ onChange: handleChange, maxLength: 9 }}
              />
              <TextField
                label="Correo"
                fullWidth
                name="E_MailL"
                value={contact.E_MailL || ""}
                type="email"
                margin="normal"
                size="small"
                onChange={handleChange}
              />
              <TextField
                label="Profesión"
                fullWidth
                name="Profession"
                value={contact.Profession || ""}
                margin="normal"
                size="small"
                onChange={handleChange}
              />
              <TextField
                label="Notas"
                fullWidth
                name="Notes1"
                value={contact.Notes1 || ""}
                margin="normal"
                size="small"
                multiline
                inputProps={{ onChange: handleChange, minRows: 4 }}  
              />
            </GridItem>
          </GridContainer>
        </form>
      </DialogContent>
      <DialogActions className={classes.modalFooter}>
        <Button
          onClick={handleSave}
          color={props.themeContext.buttonColorSuccess}
        >
          Guardar
        </Button>
        <Button
          color={props.themeContext.buttonColorDanger}
          onClick={handleClose}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
});
